import { createReducer } from "../../../_common/common.ts";
import { SET_DOCUMENTS, SET_DOCUMENT_TYPE } from "../actions/constants.js";

const initialState = {
    documents: null,
    documentType: null,
};

export const documents = createReducer(initialState, {
    [SET_DOCUMENTS]: (state, payload) => {
        state.documents = [...payload].reverse();;
        return state;
    },
    [SET_DOCUMENT_TYPE]: (state, payload) => {
        state.documentType = payload;
        return state;
    },
});
